module.exports = __webpack_public_path__ + "media/images/pic/schab-ca46a02231819d11d90cd02c00fcc39d.webp";